import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { Observable, asyncScheduler } from 'rxjs';
import { map, observeOn, startWith } from 'rxjs/operators';
import { AuthenticationService, UserService } from 'src/shared/auth';

@Component({
    standalone: false,
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    encapsulation: ViewEncapsulation.None

})
export class UserMenuComponent implements OnInit {
    constructor(private readonly userService: UserService, private readonly authService: AuthenticationService) {}

    @Input()
    userLogo: string;
    readonly defaultLogo: string = '../../assets/images/default-user.jpg';
    userLogoOrDefaultLogo$: Observable<string>;

    errorHandler(event: Event): void {
        (event.target as HTMLImageElement).src = this.defaultLogo;
    }

    ngOnInit(): void {
        this.userLogoOrDefaultLogo$ = this.userService.currentUser$.pipe(
            map(currentUser => _.get(currentUser, 'Logo') || this.userLogo || this.defaultLogo),
            startWith(this.userLogo || this.defaultLogo),
            observeOn(asyncScheduler)
        );
    }

    logout() {
        this.authService.logout();
    }
}
